import React, { createContext, useContext, useEffect, useState, useCallback } from "react";

const WishlistContext = createContext(null);
export const useWishlist = () => useContext(WishlistContext);

export const WishlistProvider = ({ children }) => {
  const [items, setItems] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem("vyron_wishlist") || "[]");
    } catch {
      return [];
    }
  });

  useEffect(() => {
    localStorage.setItem("vyron_wishlist", JSON.stringify(items));
  }, [items]);

  const has = useCallback((slug) => items.some((i) => i.slug === slug), [items]);

  const toggle = useCallback((product) => {
    setItems((prev) =>
      prev.some((i) => i.slug === product.slug)
        ? prev.filter((i) => i.slug !== product.slug)
        : [...prev, { slug: product.slug, name: product.name, price: product.price, image: product.images?.[0], tagline: product.tagline }]
    );
  }, []);

  const remove = useCallback((slug) => setItems((prev) => prev.filter((i) => i.slug !== slug)), []);

  return (
    <WishlistContext.Provider value={{ items, has, toggle, remove, count: items.length }}>
      {children}
    </WishlistContext.Provider>
  );
};
